var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.62025 13.9928H4.7595C4.344 13.9928 4.00725 13.656 4.00725 13.2405V11.379C4.00725 11.1795 3.92775 10.9883 3.78675 10.8473L2.4705 9.531C2.1765 9.237 2.1765 8.76075 2.4705 8.4675L3.80025 7.13775C3.933 7.005 4.00725 6.82575 4.00725 6.63825V4.7595C4.00725 4.344 4.344 4.00725 4.7595 4.00725H6.621C6.8205 4.00725 7.01175 3.92775 7.15275 3.78675L8.469 2.4705C8.763 2.1765 9.23925 2.1765 9.5325 2.4705L10.8488 3.78675C10.9898 3.92775 11.181 4.00725 11.3805 4.00725H13.242C13.6575 4.00725 13.9943 4.344 13.9943 4.7595V6.621C13.9943 6.8205 14.0738 7.01175 14.2148 7.15275L15.531 8.469C15.825 8.763 15.825 9.23925 15.531 9.5325L14.2148 10.8488C14.0738 10.9898 13.9943 11.181 13.9943 11.3805V13.242C13.9943 13.6575 13.6575 13.9943 13.242 13.9943H11.3805C11.181 13.9943 10.9898 14.0738 10.8488 14.2148L9.5325 15.531C9.2385 15.825 8.76225 15.825 8.469 15.531L7.15275 14.2148C7.011 14.0715 6.81975 13.9928 6.62025 13.9928Z",
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.875L8.4375 10.6875L6.75 9",
    stroke: "#098E1D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.c4b6fb686df18a7e33ab5bd67f4692c1.svg";
export { ForwardRef as ReactComponent };